/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  eye_view,
  information_Icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import DateRange from "../../components/DateRange/DateRange";
import { Table } from "../../components/Table/Table";
import Topbar from "../../components/Topbar/Topbar";
import { get, post } from "../../Services/ApiHandler";
import { RZP_KEY, URLS } from "../../Services/Constant";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useRazorpay } from "react-razorpay";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { checkPermission } from "../redux/api/PermissionManager";
import UnReadNotificationPopup from "../../components/UnReadNotificationPopup";

const MMCDeactiveList = ({ property_id }) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const { error, Razorpay } = useRazorpay();
  const [selectedOwners, setSelectedOwners] = useState([]);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [submissionDescription, setSubmissionDescription] = useState("");
  const [isViewDetails, setIsViewDetails] = useState({
    ispopUp: false,
    details: {},
  });
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    property: property_id ? { value: property_id } : "",
    owner: "",
    search: paginationData?.[path]?.search ?? "",
    unread_only: false,
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
    properties: [],
  });
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    getOwnerList();
    getProperties();
  }, []);

  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, search: selectedFilter.search },
    }));
  }, [
    selectedFilter.owner,
    selectedFilter.property,
    selectedFilter.search,
    page,
    selectedFilter?.unread_only,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  useEffect(() => {
    console.log("error accured", error);
    if (error) {
      toast.error(error);
    }
  }, [error]);

  const getList = async (pageNumber = 1) => {
    const { property, from, owner, search, to, unread_only } = selectedFilter;
    const payload = new FormData();
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (property) {
      payload.append("property", property?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    const res = await post(
      `${URLS.MMC_TRANSACTIONS_LIST}cancel_pending&page=${pageNumber}&unread_only=${unread_only}`,
      payload,
    );
    console.log("mmc suspended list", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setTransactions(res?.data);
    }
  };

  //get properties
  const getProperties = async () => {
    const res = await get(URLS.PROPERTIES_DROPDOWN);
    console.log("properties dropdown", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, properties: modifiedList }));
    }
  };

  // get owners list
  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ row }) => {
          const pageSize = 10;
          const isSelected = selectedOwners.includes(
            row.original.unread_notification_id,
          );

          const handleCheckboxChange = (e) => {
            if (e.target.checked) {
              setSelectedOwners((prev) => [
                ...prev,
                row.original.unread_notification_id,
              ]);
            } else {
              setSelectedOwners((prev) =>
                prev.filter((id) => id !== row.original.unread_notification_id),
              );
            }
          };

          return (
            <div
              style={{
                flexDirection: "row",
                alignItems: "center",
                display: "flex",
                gap: 5,
              }}
            >
              <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>
              {row?.original?.has_unread_notification && (
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleCheckboxChange}
                  style={{ width: 20, height: 20, marginTop: 9 }}
                />
              )}
              {/* {!row?.original?.has_unread_notification && (
                <img
                  src={eye_view}
                  style={{ width: 20, height: 20, marginTop: 5 }}
                  onChange={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                  onClick={() => {
                    setIsViewDetails((prev) => ({
                      ...prev,
                      ispopUp: true,
                      details: row?.original,
                    }));
                  }}
                />
              )} */}
            </div>
          );
          // const pageSize = 10;
          // return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
        // Cell: ({ value, row }) => {
        //   return <p className="red">{(page - 1) * 10 + (row.index + 1)}</p>;
        // },
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div
              onClick={() => {
                navigate("/property-details", {
                  state: {
                    id: row.original?.property_id,
                    owner: row.original?.owner_id,
                    category_id: row.original?.category_id,
                  },
                });
              }}
              className="text-nowrap"
            >
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.property_code}</p>
            </div>
          );
        },
      },
      // {
      //   Header: "Suspended ID",
      //   accessor: "suspended_id",
      //   Cell: ({ value, row }) => {
      //     return <p>{value}</p>;
      //   },
      // },
      {
        Header: "Suspended Date",
        accessor: "end_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Request Date",
        accessor: "cancelled_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: " Status",
        accessor: "invoice_status",
        Cell: ({ value, row }) => {
          return (
            <button className="deactive-btn w-80 px-1 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              {value}
            </button>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        const [showTooltip, setShowTooltip] = useState(false);

        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <div style={{ position: "relative", display: "inline-block" }}>
                <button
                  onClick={() => setShowTooltip((prev) => !prev)}
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  className="cust-btn"
                >
                  <img
                    src={information_Icon}
                    alt=""
                    className="edit-btn"
                    style={{ width: 20, height: 20 }}
                  />
                </button>

                {showTooltip && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "125%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "#333",
                      color: "#fff",
                      padding: "6px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      zIndex: 999,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                      pointerEvents: "none",
                    }}
                  >
                    Still Property In Live
                    {/* Tooltip Arrow */}
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        borderWidth: "5px",
                        borderStyle: "solid",
                        borderColor: "#333 transparent transparent transparent",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        );
      },
    };
    return [...d, action];
  }, [page, selectedOwners]);
  const handleSumbit = async () => {
    let payload = {
      ids: selectedOwners,
      description: submissionDescription,
    };

    try {
      let url = URLS.NOTIFICATION_COUNTREDUCE;
      let res = await post(url, payload);
      if (res?.status === "success") {
        // console.log("Description:", submissionDescription);
        toast.success("Read Notification has be Success");
        setShowSubmitPopup(false);
        setSubmissionDescription("");
        setSelectedOwners([]);
        getList();
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };
  return (
    <div>
      {!property_id && <Topbar header={"MMC"} subHead={"MMC Deactive"} />}
      <div
        style={{
          width: "100%",
        }}
      >
        <div
          className="d-flex mb-4"
          style={{
            flexDirection: "row",
            gap: 50,
            // justifyContent: "space-between",
            width: "100%",
          }}
        >
          <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
            Total:{count}
          </h2>
          {/* <div className="d-flex" style={{ alignItems: "center" }}>
            <input
              type="checkbox"
              checked={selectedFilter?.unread_only}
              onChange={() =>
                handleChangeFilter("unread_only", !selectedFilter?.unread_only)
              }
            />{" "}
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 ">
              Check New Notification
            </p>
           
          </div> */}
        </div>
        <div className="d-flex gap-3">
          <div
            style={{
              background: "#6B00D8",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 9,
              fontSize: "16px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Owner List
          </div>
        </div>
      </div>

      <div className="d-flex ac-je mt-3 gap-3 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        {!property_id && (
          <Select
            className="location-search"
            options={optionsList?.owners}
            onChange={(e) => {
              handleChangeFilter("owner", e);
            }}
            value={selectedFilter?.owner}
            placeholder={"Owners"}
          />
        )}
        {!property_id && (
          <Select
            className="location-search"
            options={optionsList.properties}
            value={selectedFilter.property}
            onChange={(e) => {
              handleChangeFilter("property", e);
            }}
            placeholder={"Property"}
          />
        )}
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img src={Search_icon} className="search here" alt="" />
        </div>
      </div>
      {selectedOwners.length > 0 && (
        <div
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mt-2 "
          style={{ width: 90 }}
          onClick={() => setShowSubmitPopup(true)}
        >
          <p>Submit</p>
        </div>
      )}
      {/* </div> */}
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={transactions}
        show={true}
        getRowProps={(row) => ({
          style: {
            backgroundColor: row.original.has_unread_notification
              ? "#eeeeee91"
              : "#fff",
          },
        })}
      />
      {isViewDetails?.ispopUp ? (
        <UnReadNotificationPopup
          setIsViewDetails={setIsViewDetails}
          isViewDetails={isViewDetails}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default MMCDeactiveList;
